import {
    BadgePercent, BarChart3, Boxes, Building2, CreditCard, Filter, Globe, GraduationCap, Image, Inbox,
    Instagram, LayoutDashboard, LayoutTemplate, ListChecks, Megaphone, MessageSquare, MessagesSquare,
    Percent, Printer, Receipt, Rows3, Settings, ShieldCheck, Shirt, ShoppingBag, Share2,
    Signpost, Star, Store, Tag, Truck, Users, Wrench, Zap,
} from "lucide-react";
import { SHOP_NAV } from "@/lib/nav";

const ICONS = { shirts: Shirt, signs: Signpost, classifieds: Tag, classes: GraduationCap, wholesale: Percent };
const BADGES = { classifieds: "listings_live", classes: "classes_live", wholesale: "coupons_live" };
const ROOM = { signs: "signs", shirts: "white" };

/**
 * The back office menu in the order an owner actually works: finish setting up, work today's
 * orders, mind the shelves, then marketing, then the settings you touch once. The Products group
 * is the shopper header, item for item — what the customer sees is what the owner edits.
 * `store: true` groups only appear once the account rents a space.
 */
export const NAV = [
    {
        id: "setup", tone: "#3F3F46", items: [
            { label: "Setup checklist", to: "/account/wizard", icon: ListChecks, store: true },
            { label: "Dashboard", to: "/account", icon: LayoutDashboard },
        ],
    },
    {
        id: "orders", label: "Orders", store: true, tone: "#1A6FBF", items: [
            { label: "Order inbox", to: "/account/orders", icon: Inbox, badge: "orders_open" },
            { label: "Service requests", to: "/account/service-requests", icon: Wrench, admin: true, badge: "service_requests_new", alert: true },
            { label: "Gmail filter guide", to: "/account/email-guide", icon: Filter },
        ],
    },
    {
        id: "products", label: "Products", store: true, tone: "#16A46B", items: [
            { label: "All listings", to: "/account/products", icon: Rows3, badge: "products_live" },
            ...SHOP_NAV.map((n) => ({ label: n.label, to: n.office, icon: ICONS[n.key], badge: BADGES[n.key], room: ROOM[n.key] })),
            { label: "DTF gang sheet films", to: "/account/gang-sheets", icon: Zap, room: "dtf" },
        ],
    },
    {
        id: "marketing", label: "Marketing", store: true, tone: "#C4801A", items: [
            { label: "Drop cards", to: "/account/drop-cards", icon: Instagram },
            { label: "Billboards", to: "/account/billboards", icon: Megaphone, badge: "billboards_live" },
            { label: "Homepage window", to: "/account/homepage", icon: LayoutTemplate },
        ],
    },
    {
        id: "profile", label: "Profile", store: true, tone: "#B3261E", items: [
            { label: "Store profile", to: "/account/store", icon: Settings },
            { label: "Web address", to: "/account/domain", icon: Globe },
            { label: "What I sell", to: "/account/store#counters", icon: Rows3 },
            { label: "Store billboard", to: "/account/store#billboard", icon: Image },
            { label: "Pickup & shipping", to: "/account/store#ops", icon: Truck },
            { label: "Social profiles", to: "/account/store#socials", icon: Share2 },
            { label: "Shipping labels", icon: Printer, soon: true },
            { label: "Staff accounts", icon: Users, soon: true },
        ],
    },
    {
        id: "consignment", label: "Consignment", store: true, tone: "#8B4FA8", items: [
            { label: "Consignment mode", to: "/account/consignment", icon: Boxes },
        ],
    },
    {
        id: "spaces", label: "Plans", store: true, tone: "#0F7A80", items: [
            { label: "My plan", to: "/account/sell", icon: Building2 },
            { label: "Virtual Brick & Mortar", to: "/spaces", icon: Globe },
        ],
    },
    {
        id: "payouts", label: "Payouts", store: true, tone: "#067647", items: [
            { label: "Get paid", to: "/account/payouts", icon: CreditCard },
            { label: "Payout history", to: "/account/payout-history", icon: Receipt },
            { label: "Sales reports", to: "/account/analytics", icon: BarChart3 },
        ],
    },
    {
        id: "community", label: "Community", tone: "#A1417C", items: [
            { label: "Shop inbox", to: "/account/inbox", icon: MessageSquare, badge: "unread_messages", store: true },
            { label: "Reviews", to: "/account/reviews", icon: Star, store: true },
            { label: "Community board", to: "/community", icon: MessagesSquare, badge: "community_threads" },
            { label: "Purchases", to: "/account/purchases", icon: ShoppingBag },
            { label: "Wholesale pass", to: "/wholesale", icon: BadgePercent },
            { label: "Open a shop", to: "/spaces", icon: Store, noStoreOnly: true },
        ],
    },
    {
        id: "mall", label: "Platform admin", admin: true, tone: "#18181B", items: [
            { label: "Admin dashboard", to: "/admin", icon: ShieldCheck },
        ],
    },
];
